import Api from './Api';
import { Flow } from '../../model/workflowEditor/flow/types';

class FlowsApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '/Flows', headers);
  }

  get = (botId: string) => this.instance.get(`/${botId}`);

  create = (botId: string, flow: Flow) => this.instance.post(`/${botId}`, flow);

  update = (botId: string, flow: Flow) => this.instance.put(`/${botId}/${flow.id!}`, flow);

  delete = (botId: string, flowId: string) => this.instance.delete(`/${botId}/${flowId}`);
}

export default FlowsApi;
